import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import imgLogo from "../../../src/logo-Ykbut.png";
import "../layouts/navbar.css";
import axios from "axios";

function SideNav() {
    const navigate = useNavigate();
    const location = useLocation();

    const [dropdownStates, setDropdownStates] = useState({
        user: false,
        tentang: false,
        unit_operasional: false,
        tata_kelola: false,
        keberlanjutan: false,
        sumber_daya: false,
        ruang_media: false,
    });

    // === Auto open parent menu berdasarkan route aktif ===
    useEffect(() => {
        const routeParentMap = {
            "/user": "user",
            "/sekilas-perusahaan": "tentang",
            "/struktur": "tentang",
            "/jejak": "tentang",
            "/utschool": "unit_operasional",
            "/dcare": "unit_operasional",
            "/poliklinik": "unit_operasional",
            "/pelaporan": "tata_kelola",
            "/program": "keberlanjutan",
            "/programgroup": "keberlanjutan",
            "/entitas": "keberlanjutan",
            "/career": "sumber_daya",
            "/recruit": "sumber_daya",
            "/faq": "sumber_daya",
            "/galeri": "ruang_media",
            "/galeri_group": "ruang_media",
            "/blog": "ruang_media",
            "/blog_group": "ruang_media",
            "/banner": "ruang_media",
        };

        const currentPath = location.pathname;
        const matchedParent = Object.keys(routeParentMap).find((prefix) =>
            currentPath.startsWith(prefix)
        );

        if (matchedParent) {
            setDropdownStates((prev) => ({
                ...prev,
                [routeParentMap[matchedParent]]: true,
            }));
        }
    }, [location.pathname]);

    // === Toggle menu ===
    const handleDropdownToggle = (menu) => {
        setDropdownStates((prev) => {
            const updated = {};
            Object.keys(prev).forEach((key) => {
                updated[key] = key === menu ? !prev[key] : false;
            });
            return updated;
        });
    };

    // === Logout ===
    const handleLogout = async () => {
        const token = localStorage.getItem("token");
        if (token) {
            try {
                await axios.post(
                    `${process.env.REACT_APP_API_URL}/auth/logout`,
                    {},
                    { headers: { Authorization: token } }
                );
                localStorage.removeItem("token");
                localStorage.removeItem("tokenExpiry");
                navigate("/");
            } catch (error) {
                console.error("Error logging out:", error);
            }
        } else {
            navigate("/");
        }
    };

    const isActive = (path) => location.pathname === path;
    const isStartsWith = (prefix) => location.pathname.startsWith(prefix);

    return (
        <aside className="main-sidebar sidebar-light-primary elevation-4">
            {/* === LOGO === */}
            <Link to="/" className="brand-link">
                <span className="brand-text font-weight-light">
                    <img className="img-logo" src={imgLogo} alt="Logo YKBUT" />
                </span>
            </Link>

            {/* === SIDEBAR MENU === */}
            <nav className="mt-2">
                <ul className="nav nav-pills nav-sidebar flex-column" role="menu">
                    {/* DASHBOARD */}
                    <li className="nav-item">
                        <Link
                            to="/dashboard"
                            className={`nav-link ${isActive("/dashboard") ? "active" : ""}`}
                        >
                            <i className="nav-icon fas fa-chart-bar" />
                            <p>Dashboard</p>
                        </Link>
                    </li>

                    {/* USER */}
                    <li className={`nav-item ${dropdownStates.user ? "menu-open" : ""}`}>
                        <button
                            type="button"
                            onClick={() => handleDropdownToggle("user")}
                            className={`nav-link ${isStartsWith("/user") ? "active-parent" : ""}`}
                        >
                            <i className="nav-icon fas fa-user" />
                            <p>
                                User
                                <i className="right fas fa-angle-right" />
                            </p>
                        </button>
                        <ul className="nav nav-treeview">
                            <li className="nav-item">
                                <Link
                                    to="/user"
                                    className={`nav-link ${isActive("/user") ? "active" : ""}`}
                                >
                                    <i className="far fa-circle nav-icon" />
                                    <p>List user</p>
                                </Link>
                            </li>
                        </ul>
                    </li>

                    {/* TENTANG */}
                    <li className={`nav-item ${dropdownStates.tentang ? "menu-open" : ""}`}>
                        <button
                            type="button"
                            onClick={() => handleDropdownToggle("tentang")}
                            className={`nav-link ${
                                isStartsWith("/sekilas-perusahaan") ||
                                isStartsWith("/struktur") ||
                                isStartsWith("/jejak")
                                    ? "active-parent"
                                    : ""
                            }`}
                        >
                            <i className="nav-icon far fa-building" />
                            <p>
                                Tentang
                                <i className="right fas fa-angle-right" />
                            </p>
                        </button>
                        <ul className="nav nav-treeview">
                            <li className="nav-item">
                                <Link
                                    to="/sekilas-perusahaan"
                                    className={`nav-link ${
                                        isActive("/sekilas-perusahaan") ? "active" : ""
                                    }`}
                                >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Sekilas Perusahaan</p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    to="/struktur"
                                    className={`nav-link ${isActive("/struktur") ? "active" : ""}`}
                                >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Struktur Organisasi</p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    to="/jejak"
                                    className={`nav-link ${isActive("/jejak") ? "active" : ""}`}
                                >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Jejak Langkah</p>
                                </Link>
                            </li>
                        </ul>
                    </li>

                    {/* UNIT OPERASIONAL */}
                    <li
                        className={`nav-item ${dropdownStates.unit_operasional ? "menu-open" : ""}`}
                    >
                        <button
                            type="button"
                            onClick={() => handleDropdownToggle("unit_operasional")}
                            className={`nav-link ${
                                isStartsWith("/utschool") ||
                                isStartsWith("/dcare") ||
                                isStartsWith("/poliklinik")
                                    ? "active-parent"
                                    : ""
                            }`}
                        >
                            <i className="nav-icon fas fa-network-wired" />
                            <p>
                                Unit Operasional
                                <i className="right fas fa-angle-right" />
                            </p>
                        </button>
                        <ul className="nav nav-treeview">
                            <li className="nav-item">
                                <Link
                                    to="/utschool"
                                    className={`nav-link ${isActive("/utschool") ? "active" : ""}`}
                                >
                                    <i className="far fa-circle nav-icon" />
                                    <p>UT School</p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    to="/dcare"
                                    className={`nav-link ${isActive("/dcare") ? "active" : ""}`}
                                >
                                    <i className="far fa-circle nav-icon" />
                                    <p>D'Care</p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    to="/poliklinik"
                                    className={`nav-link ${
                                        isActive("/poliklinik") ? "active" : ""
                                    }`}
                                >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Poliklinik</p>
                                </Link>
                            </li>
                        </ul>
                    </li>

                    {/* TATA KELOLA */}
                    <li
                        className={`nav-item ${
                            dropdownStates.tata_kelola ||
                            isStartsWith("/pelaporan") ||
                            isStartsWith("/etik")
                                ? "menu-open"
                                : ""
                        }`}
                    >
                        <button
                            type="button"
                            onClick={() => handleDropdownToggle("tata_kelola")}
                            className={`nav-link ${
                                isStartsWith("/pelaporan") || isStartsWith("/etik")
                                    ? "active-parent"
                                    : ""
                            }`}
                        >
                            <i className="nav-icon fas fa-file-invoice" />
                            <p>
                                Tata Kelola
                                <i className="right fas fa-angle-right" />
                            </p>
                        </button>

                        <ul className="nav nav-treeview">
                            <li className="nav-item">
                                <Link
                                    to="/pelaporan"
                                    className={`nav-link ${isActive("/pelaporan") ? "active" : ""}`}
                                >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Sistem Pelaporan Pelanggaran</p>
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link
                                    to="/etik"
                                    className={`nav-link ${isActive("/etik") ? "active" : ""}`}
                                >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Kode Etik YKBUT</p>
                                </Link>
                            </li>
                        </ul>
                    </li>

                    {/* KEGIATAN / KEberlanjutan */}
                    <li className={`nav-item ${dropdownStates.keberlanjutan ? "menu-open" : ""}`}>
                        <button
                            type="button"
                            onClick={() => handleDropdownToggle("keberlanjutan")}
                            className={`nav-link ${
                                isStartsWith("/program") ||
                                isStartsWith("/programgroup") ||
                                isStartsWith("/entitas")
                                    ? "active-parent"
                                    : ""
                            }`}
                        >
                            <i className="nav-icon fas fa-project-diagram" />
                            <p>
                                Keberlanjutan
                                <i className="right fas fa-angle-right" />
                            </p>
                        </button>
                        <ul className="nav nav-treeview">
                            <li className="nav-item">
                                <Link
                                    to="/program"
                                    className={`nav-link ${isActive("/program") ? "active" : ""}`}
                                >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Program</p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    to="/programgroup"
                                    className={`nav-link ${
                                        isActive("/programgroup") ? "active" : ""
                                    }`}
                                >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Program Group</p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    to="/entitas"
                                    className={`nav-link ${isActive("/entitas") ? "active" : ""}`}
                                >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Entitas</p>
                                </Link>
                            </li>
                        </ul>
                    </li>

                    {/* SUMBER DAYA MANUSIA */}
                    <li className={`nav-item ${dropdownStates.sumber_daya ? "menu-open" : ""}`}>
                        <button
                            type="button"
                            onClick={() => handleDropdownToggle("sumber_daya")}
                            className={`nav-link ${
                                isStartsWith("/career") ||
                                isStartsWith("/recruit") ||
                                isStartsWith("/faq")
                                    ? "active-parent"
                                    : ""
                            }`}
                        >
                            <i className="nav-icon fas fa-info-circle" />
                            <p>
                                Sumber Daya Manusia
                                <i className="right fas fa-angle-right" />
                            </p>
                        </button>
                        <ul className="nav nav-treeview">
                            <li className="nav-item">
                                <Link
                                    to="/career"
                                    className={`nav-link ${isActive("/career") ? "active" : ""}`}
                                >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Berkarir YKBUT</p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    to="/recruit"
                                    className={`nav-link ${isActive("/recruit") ? "active" : ""}`}
                                >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Info Rekrutmen</p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    to="/faq"
                                    className={`nav-link ${isActive("/faq") ? "active" : ""}`}
                                >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Tanya Jawab</p>
                                </Link>
                            </li>
                        </ul>
                    </li>

                    {/* RUANG MEDIA */}
                    <li className={`nav-item ${dropdownStates.ruang_media ? "menu-open" : ""}`}>
                        <button
                            type="button"
                            onClick={() => handleDropdownToggle("ruang_media")}
                            className={`nav-link ${
                                isStartsWith("/galeri") ||
                                isStartsWith("/galeri_group") ||
                                isStartsWith("/blog") ||
                                isStartsWith("/blog_group") ||
                                isStartsWith("/banner")
                                    ? "active-parent"
                                    : ""
                            }`}
                        >
                            <i className="nav-icon fas fa-photo-video" />
                            <p>
                                Ruang Media
                                <i className="right fas fa-angle-right" />
                            </p>
                        </button>
                        <ul className="nav nav-treeview">
                            <li className="nav-item">
                                <Link
                                    to="/galeri"
                                    className={`nav-link ${isActive("/galeri") ? "active" : ""}`}
                                >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Data Galeri</p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    to="/blog"
                                    className={`nav-link ${isActive("/blog") ? "active" : ""}`}
                                >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Data Blog</p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    to="/banner"
                                    className={`nav-link ${isActive("/banner") ? "active" : ""}`}
                                >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Banner</p>
                                </Link>
                            </li>
                        </ul>
                    </li>

                    {/* KONTAK */}
                    <li className="nav-item">
                        <Link
                            to="/kontak"
                            className={`nav-link ${isActive("/kontak") ? "active" : ""}`}
                        >
                            <i className="nav-icon fas fa-user" />
                            <p>Kontak</p>
                        </Link>
                    </li>

                    {/* Header Images */}
                    <li className="nav-item">
                        <Link
                            to="/header-images"
                            className={`nav-link ${isActive("/header-images") ? "active" : ""}`}
                        >
                            <i className="nav-icon fas fa-image" />
                            <p>Header Images</p>
                        </Link>
                    </li>

                    {/* LOGOUT */}
                    <li className="nav-item">
                        <Link to="/" onClick={handleLogout} className="nav-link">
                            <i className="nav-icon fas fa-sign-out-alt" />
                            <p>Logout</p>
                        </Link>
                    </li>
                </ul>
            </nav>
        </aside>
    );
}

export default SideNav;
